import * as React from "react";
import { getFeatureToggles } from "@teamprevent/common/getFeatureToggles";
import * as FeatureToggleNames from "@teamprevent/common/featureToggleNames";

import { connect } from "react-redux";
import { values } from "lodash";

import { OldProgressBarQuestionnaireSection } from "@teamprevent/common/questionnaires/components/OldProgressBarQuestionnaireSection";
import { CheckboxQuestion } from "@teamprevent/common/questionnaires/components/questions/CheckboxQuestion";
import { DropdownQuestion } from "@teamprevent/common/questionnaires/components/questions/DropdownQuestion";
import { TextQuestion } from "@teamprevent/common/questionnaires/components/questions/TextQuestion";
import { AnsweredQuestionWithId } from "@teamprevent/common/model";
import { QuestionnairesState } from "@teamprevent/common/questionnaires/model";

import { ContextAwareCheckboxQuestion } from "@teamprevent/common/questionnaires/components/questions/ContextAwareCheckboxQuestion";

import { ApplicationState } from "../../applicationState";

interface StateProps {
    questionnaires: QuestionnairesState;
}

interface OwnProps {
    index?: number;
    readonly: boolean;
    questionnaireKey: string;
}

type Props = { questions: AnsweredQuestionWithId[] } & OwnProps;

const sectionId = "DataProtection";

class DataProtectionSectionPrintUnconnected extends React.Component<Props> {
    private readonly typeOfIdUsedId = "TypeOfIdUsed";
    private readonly wasIdConfirmedId = "WasIdConfirmed";
    private readonly immunisationWorkflowImprovementsPt1Enabled = getFeatureToggles()[FeatureToggleNames.ImmunisationWorkflowImprovementsPt1];

    public render() {
        return (
            <OldProgressBarQuestionnaireSection
                index={this.props.index}
                questionnaireKey={this.props.questionnaireKey}
                title="Data Protection"
                id={sectionId}
                readonly={this.props.readonly}
            >
                <p>In line with the UK Data Protection Act, General Data Protection Regulations
                    I am also required to confirm the following with you.</p>
                <CheckboxQuestion
                    readonly={this.props.readonly}
                    questionConfig={({
                        id: "ConsentStoreData",
                        // eslint-disable-next-line max-len
                        questionText: "Do you understand that Optima Health will be required to keep a clinical record of this consultation and that any personal and health related information that is recorded will be held on our secure online system"
                    })}
                    value="Consented"
                />
                { this.immunisationWorkflowImprovementsPt1Enabled &&
                    <ContextAwareCheckboxQuestion
                        preserveInitialQuestionText
                        questionConfig={({
                            id: "RequestDataExplained",
                            // eslint-disable-next-line max-len
                            questionText: "Do you understand that you can request a copy of your clinical notes at any time? Our registered address can be found on our website, www.optimahealth.co.uk"
                        })}
                        value="Explained"
                    />
                }
                { !this.immunisationWorkflowImprovementsPt1Enabled &&

                    <CheckboxQuestion
                        readonly={this.props.readonly}
                        questionConfig={({
                            id: "RequestDataExplained",
                            // eslint-disable-next-line max-len
                            questionText: "Do you understand that you can request a copy of your clinical notes at any time? Our registered address can be found on our website <a href=\"https://tphealth.co.uk/\" target=\"_blank\" rel=\"noopener noreferrer\">https://tphealth.co.uk/</a>"
                        })}
                        value="Explained"
                    />
                }
                { this.immunisationWorkflowImprovementsPt1Enabled &&
                    <ContextAwareCheckboxQuestion
                        preserveInitialQuestionText
                        questionConfig={({
                            id: "ConfirmPrivacyStatementExplained",
                            // eslint-disable-next-line max-len
                            questionText: "Please note that you can access our full privacy policy on our website, which clearly explains how, where, and when your personal and health data will be processed in detail."
                        })}
                        value="Explained"
                    />
                }
                { !this.immunisationWorkflowImprovementsPt1Enabled &&
                    <CheckboxQuestion
                        readonly={this.props.readonly}
                        questionConfig={({
                            id: "ConfirmPrivacyStatementExplained",
                            // eslint-disable-next-line max-len
                            questionText: "Please note that you can access our full <a href=\"https://tphealth.co.uk/privacy-statement\" target=\"_blank\" rel=\"noopener noreferrer\">Privacy Statement</a> on our website which clearly explains in detail how, where and when your personal and health data will be processed."
                        })}
                        value="Explained"
                    />
                }
                <CheckboxQuestion
                    readonly={this.props.readonly}
                    questionConfig={({
                        id: this.wasIdConfirmedId,
                        questionText: "Was the individual’s identity confirmed using any formal form of Identification?"
                    })}
                    value="Identity confirmed"
                />
                {this.getAnswerToQuestionWithId(this.wasIdConfirmedId) &&
                    <>
                        <DropdownQuestion
                            readonly={this.props.readonly}
                            questionConfig={({ id: this.typeOfIdUsedId, questionText: "If Yes please confirm the type of identification that was shown" })}
                            options={[
                                { value: "Passport", text: "Passport" },
                                { value: "Driving Licence", text: "Driving Licence" },
                                { value: "Company ID Card", text: "Company ID Card" },
                                { value: "National Identity Card", text: "National Identity Card" },
                                { value: "Other", text: "Other" }
                            ]}
                        />
                        {this.getAnswerToQuestionWithId(this.typeOfIdUsedId) === "Other" &&
                            <TextQuestion
                                mandatory
                                readonly={this.props.readonly}
                                questionConfig={({ id: "OtherIdUsed", questionText: "Please specify ID here" })}
                            />}
                    </>}
            </OldProgressBarQuestionnaireSection>
        );
    }

    private getAnswerToQuestionWithId(id: string) {
        if (this.props.questions) {
            const question = this.props.questions.find(q => q.id === id && q.sectionId === sectionId);
            if (question) {
                return question.answer;
            }
        }

        return undefined;
    }
}

const mapStateToProps = (state: ApplicationState): StateProps => ({
    questionnaires: state.questionnaires
});

const mergeProps = (stateProps: StateProps, dispatchProps: void, ownProps: OwnProps): Props => {
    const questionnaire = stateProps.questionnaires[ownProps.questionnaireKey];
    const section = questionnaire && questionnaire.sections.find(s => s.id === sectionId);
    return {
        questions: section ? values(section.questions) : [],
        ...ownProps
    };
};

export const DataProtectionSectionPrint = connect(mapStateToProps, null, mergeProps)(DataProtectionSectionPrintUnconnected);
